import { InputConfig } from "../GameConfig/GameConfig.js";

export default class InputHandler {
  constructor(game) {
    this.game = game;
    window.addEventListener("keydown", (e) => {
      if (
        e.key == InputConfig.UP ||
        e.key == InputConfig.DOWN ||
        e.key == InputConfig.ATTACK
      ) {
        this.game.keys.add(e.key);
      }
    });
    window.addEventListener("keyup", (e) => {
      if (this.game.keys.has(e.key)) {
        this.game.keys.delete(e.key);
      }
    });
  }
}
